// extracted by mini-css-extract-plugin
export default {"conflictSection":"ConflictSection_conflictSection__ywyAU","icon":"ConflictSection_icon__Ie9E2","title":"ConflictSection_title__z7YTz"};